import './style.scss';

import React from 'react';
import { connect } from 'react-redux';
import View from 'components/ui/view';
import Text from 'components/ui/text';
import Card from 'components/ui/card';
import { subscribeToAppboy, unsubscribeFromAppboy } from 'shared/models/api';

class ContactPreferences extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      promotionalEmails: false,
      newsletterEmails: false,
      announcementEmails: false,
      loading: false,
      success: false
    };
    this.togglePromotionalEmails = this.toggleState.bind(
      this,
      'promotionalEmails'
    );
    this.toggleNewsletterEmails = this.toggleState.bind(
      this,
      'newsletterEmails'
    );
    this.toggleAnnouncementEmails = this.toggleState.bind(
      this,
      'announcementEmails'
    );
  }

  componentDidMount() {
    window.analytics.ready(() => {
      const user = window.analytics.user();
      const traits = user.traits();
      this.setState({
        promotionalEmails: !!traits['Promotional Emails'],
        newsletterEmails: !!traits['Newsletter Emails'],
        announcementEmails: !!traits['Announcement Emails']
      });
    });
  }

  toggleState(name) {
    this.setState(state => ({ ...state, [name]: !state[name] }));
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.state.loading) return;
    this.setState({ loading: true, success: false });

    if (
      !this.state.promotionalEmails &&
      !this.state.newsletterEmails &&
      !this.state.announcementEmails
    )
      return this.unsubscribe();

    this.updateUser(
      {
        ['Promotional Emails']: this.state.promotionalEmails,
        ['Newsletter Emails']: this.state.newsletterEmails,
        ['Announcement Emails']: this.state.announcementEmails
      },
      () => {
        const user = window.analytics.user();
        const traits = user.traits() || {};
        const email = traits.email || '';
        subscribeToAppboy(email).then(() => {
          this.setState({ loading: false, success: true });
        });
      }
    );
  }

  unsubscribe() {
    if (this.state.loading) return;
    this.setState({ loading: true });
    this.updateUser(
      {
        ['Promotional Emails']: false,
        ['Newsletter Emails']: false,
        ['Announcement Emails']: false
      },
      () => {
        const user = window.analytics.user();
        const traits = user.traits() || {};
        const email = traits.email || '';
        unsubscribeFromAppboy(email).then(() => {
          this.setState({ loading: false });
          window.location = `https://saucey.typeform.com/to/WVHLdm?email=${email}`;
        });
      }
    );
  }

  updateUser(preferences, cb) {
    window.analytics.ready(() => {
      const user = window.analytics.user();
      const userId = user.id();
      window.analytics.identify(userId, preferences, {}, cb);
    });
  }

  render() {
    return (
      <View padding="sm" className="contact-preferences banner-padding">
        <Text title tag="h2" weight="med" size="md">
          Email Preferences
        </Text>
        <View margin="sm">
          <Card block>
            <View padding="md">
              <form
                className="row bottom-sm"
                onSubmit={e => this.handleSubmit(e)}
              >
                <View className="col-xs-12" margin="md">
                  <label htmlFor="promotional-emails">
                    <input
                      className="left"
                      type="checkbox"
                      name="promotional-emails"
                      id="promotional-emails"
                      checked={this.state.promotionalEmails}
                      onChange={this.togglePromotionalEmails}
                    />
                    <View padding={{ left: 'md' }}>
                      <Text weight="bold">Promotional Emails</Text>
                      <Text secondary>
                        Receive special discounts and promotions
                      </Text>
                    </View>
                  </label>
                </View>

                <View className="col-xs-12" margin="md">
                  <label htmlFor="newsletter-emails">
                    <input
                      className="left"
                      type="checkbox"
                      name="newsletter-emails"
                      id="newsletter-emails"
                      checked={this.state.newsletterEmails}
                      onChange={this.toggleNewsletterEmails}
                    />
                    <View padding={{ left: 'md' }}>
                      <Text weight="bold">Newsletter Emails</Text>
                      <Text secondary>
                        Guide to cocktail recipes, latest trends and helpful
                        tips
                      </Text>
                    </View>
                  </label>
                </View>

                <View className="col-xs-12" margin="lg">
                  <label htmlFor="announcement-emails">
                    <input
                      className="left"
                      type="checkbox"
                      name="announcement-emails"
                      id="announcement-emails"
                      checked={this.state.announcementEmails}
                      onChange={this.toggleAnnouncementEmails}
                    />
                    <View padding={{ left: 'md' }}>
                      <Text weight="bold">Announcement Emails</Text>
                      <Text secondary>
                        Be the first to hear about exclusive news, private
                        events and exciting new features
                      </Text>
                    </View>
                  </label>
                </View>

                <div className="col-xs-12 col-sm-3">
                  <button
                    type="submit"
                    disabled={this.state.loading}
                    className="btn-primary btn--full-width contact-preferences__submit"
                  >
                    Update
                  </button>
                </div>

                {this.state.success && (
                  <div className="col-xs-12 col-sm-6 last-sm">
                    <div className="row center-xs start-sm">
                      <div className="col-xs-12">
                        <Text
                          success
                          weight="med"
                          className="contact-preferences__success"
                        >
                          Your preferences have been updated.
                        </Text>
                      </div>
                    </div>
                  </div>
                )}

                <div className="col-xs-12 col-sm-9">
                  <div className="row center-xs end-sm">
                    <div className="col-xs-12">
                      <button
                        onClick={() => this.unsubscribe()}
                        disabled={this.state.loading}
                        className="btn--inline text-secondary link-text contact-preferences__unsubscribe"
                      >
                        Unsubscribe from all emails.
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </View>
          </Card>
        </View>
      </View>
    );
  }
}

const ConnectedContactPreferences = connect(
  state => ({
    user: state.login.user
  }),
  {}
)(ContactPreferences);

export default ConnectedContactPreferences;
